<template>
    <div style="text-align: center">
        <h2>ตัวอย่างเงินเดือน</h2><br>
        <div class="col text-center">&nbsp;
            <button  type="button"
                     @click="submitPreviewSalaryMonth"
                     class="btn btn-primary">
                <icon name="print" style="width: 25px"></icon>
                พิมพ์
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelPreviewSalaryMonth"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
        <!--        <pre class="alert-success">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import moment from "moment"

    export default {
        name: "preview-salary-month-modal",
        data() {
            return {
                currentDate: "",
            };
        },
        computed:{
            ...mapState({

            })
        },
        methods:{
            submitPreviewSalaryMonth(){
                this.$emit("submit",1)
            },
            cancelPreviewSalaryMonth(){
                this.$emit("submit",0)
            },
        }
    }
</script>

<style scoped>

</style>